import { useTranslation } from 'react-i18next';

import { CommentSearchResult } from '@/shared/components/comments/CommentSearchResult';
import type { SearchResult, SearchResultHighlights } from '@/shared/registry/types';

/**
 * A comment on a knowledge-base page in the global search results (entity type `comment`; meta: pageId, pageTitle). It has
 * the visibility of its page (gone with it into the trash); the row opens the page at its comments.
 */
export function WikiCommentSearchResult({
  result,
  highlights,
}: {
  result: SearchResult;
  highlights?: SearchResultHighlights;
}) {
  const { t } = useTranslation('wiki');
  return (
    <CommentSearchResult
      result={result}
      highlights={highlights}
      heading={t('search.commentOnPage', { title: result.meta?.pageTitle ?? '' })}
    />
  );
}
